import { createSelector } from 'reselect';
import {
    filter, get, isEmpty, map, find,
} from 'lodash';
import { CONSTANTS } from 'services/constants';
import { buildDestinationsSelector } from 'store/selectors/destinations.selector';
import { groupBy } from 'lodash/collection';

/**
 * Base Selectors
 */
const getState = state => state;
const getMetaEntities = state => state.app.metaDatabase.regions;
export const getRegions = state => state.app.database.regions;
const getAlternativeAttributes = state => state.app.database.alternativeAttributes;
const getEntitySlug = (state, slug) => slug;


/** * Meta Selector Builders */
export const buildMetaRegionsSelector = () => createSelector([getMetaEntities], (entities) =>
{
    if (!isEmpty(entities))
    {
        return entities[CONSTANTS.DATA.ALL_ID];
    }

    return {};
});


/** * Selector Builders */
export const buildRegionsSelector = (includeRooms = true) => createSelector([getRegions, buildDestinationsSelector(includeRooms), getAlternativeAttributes], (entities, destinations, alternativeAttributes) =>
{
    if (!isEmpty(entities)) return mapRegions(entities, destinations, alternativeAttributes);

    return [];
});

/** * Selector Builders */
export const buildRegionBySlugSelector = () => createSelector([getRegions, getEntitySlug, buildDestinationsSelector()], (entities, slug, destinations) =>
{
    if (!isEmpty(entities))
    {
        const region = find(entities, _region => slug === _region.slug);

        if (!region)
            return {};

        const destinationsByRegion = groupBy(destinations, 'region_id');
        const regionDestinations = get(destinationsByRegion, region.id, []);

        return {
            ...region,
            destinations: regionDestinations,
        };
    }

    return {};
});


export const buildSimpleRegionSelector = () => createSelector([getState, getRegions], (state, entities) => entities);

function mapRegions(entities, destinations, alternativeAttributes)
{
    return map(entities, (region) =>
    {
        const destinationsByRegion = get(groupBy(destinations, 'region_id'), region.id, []).map(destination => ({
            ...destination,
            hotels_count: destinations.filter(_destination => _destination.parent_id === destination.id
                || _destination.id === destination.id
            ).reduce((count, _destination) => count + _destination.hotels.length, 0),
        }));


        return {
            ...region,
            destinations: destinationsByRegion,
            alternativeAttributes: filter(alternativeAttributes, { entity_id: region.id, entity_type: 'Region' }),
        };
    });
}
